import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { login, logout } from 'redux-implicit-oauth2'
import { loginInProgress, loginSuccess, loginFailed } from '../ducks/authStatus'
import { fetchMe } from '../ducks/me'
import Component from '../components/App/index'
import config from '../config'

function mapStateToProps(state, ownProps) {
  return {
    auth: state.auth,
    authStatus: state.authStatus,
    me: state.me,
    children: ownProps.children,
  }
}

function mapDispatchToProps(dispatch) {
  const actions = {
    login: () => login(config),
    logout,
    loginInProgress,
    loginSuccess,
    loginFailed,
    fetchMe,
    push
  }

  return { actions: bindActionCreators(actions, dispatch) }
}

export default connect(mapStateToProps, mapDispatchToProps)(Component)



// WEBPACK FOOTER //
// ./containers/App.js